import { Attendance } from "@/@types/esus/Attendance";
import { DentalAttendance } from "@/@types/esus/DentalAttendance";
import { GroupActivity } from "@/@types/esus/GroupActivity";
import { SharedCare } from "@/@types/esus/SharedCare";
import { esusApi } from "@/services/api";

export type DetailedCitizenAttendancesIndicatorM2Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
	citizenId: number;
};

export class DetailedCitizenAttendancesIndicatorM2 {
	id: number = 0;
	cpf?: string;
	cns?: string;
	birthdate: string = "";
	fullName: string = "";
	area?: string;
	motherName?: string;
	gender?: number;
	street?: string;
	houseNumber?: string;
	neighborhood?: string;
	phone?: string;
	healthTeamId: number = 0;
	healthTeamIne: string = "";
	healthTeamName: string = "";
	attendances?: Attendance[];
	dentalAttendances?: DentalAttendance[];
	groupActivities?: GroupActivity[];
	sharedCares?: SharedCare[];
}

export async function getDetailedCitizenAttendancesIndicatorM2({
	uf,
	ibgeCode,
	...params
}: DetailedCitizenAttendancesIndicatorM2Params) {
	const response = await esusApi.get<DetailedCitizenAttendancesIndicatorM2>(
		`/uf/${uf}/city/${ibgeCode}/indicator/emulti/m2/detailed-citizen-attendances`,
		params
	);
	return response.data ?? new DetailedCitizenAttendancesIndicatorM2();
}
